import { Form, Input } from 'antd'
import { tabFields } from '~app/configuration/labels'
import type { AutoFocusedFields } from '~app/hooks/useField'
import i18n from '~app/i18n/i18n'

interface Props {
  recipientMetadataFields: AutoFocusedFields<{ name: string }>
}

const RecipientMetadata = ({ recipientMetadataFields }: Props) => {
  return (
    <Form.Item
      label={i18n.t('documentView.to.title')}
      style={{ marginBottom: 8 }}
    >
      <Input
        {...recipientMetadataFields.name.inputField}
        placeholder={i18n.t('documentView.to.placeholder')}
        tabIndex={tabFields.recipientMetadata}
      />
    </Form.Item>
  )
}

export default RecipientMetadata
